/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { InfoBox } from "../../components/Infobox";
import { colors } from "../../components/colors";
import { StyledText } from "../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { CircleContainer } from "../../components/CircleContainer";

const infoBoxStyle = css`
  width: 100%;
  justify-content: center;
  padding: 24px;
  border: 1px solid ${colors.ctaInactive};
`;

const textWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const textSubWrapperStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 8px;
`;

export const DeliveryRulesPlaceholder = () => {
  return (
    <InfoBox css={infoBoxStyle} backgroundColor={colors.white}>
      <div css={textWrapperStyle}>
        <CircleContainer
          width="40px"
          height="40px"
          backgroundColor={colors.ctaLight}
        >
          <StyledText
            color={colors.ctaMain}
            className="bodyHeaderTwoSemibold mb-0"
          >
            <FontAwesomeIcon icon={solid("section")} />
          </StyledText>
        </CircleContainer>
        <div css={textSubWrapperStyle}>
          <StyledText
            color={colors.textPrimary}
            className="bodyTextSemibold mb-0"
          >
            No delivery rule groups created yet!
          </StyledText>
          <StyledText
            color={colors.textSecondary}
            className="bodySubtextRegular mb-0"
          >
            Click in the top right corner to create your first.
          </StyledText>
        </div>
      </div>
    </InfoBox>
  );
};
